module.exports = __webpack_public_path__ + "img/Avatar-26.e2026ac1.svg";